export const THEME_COLORS = [
  'neutral',
  'blue',
  'green',
  'emerald',
  'violet',
  'orange',
  'rose',
] as const;

export type ThemeColor = (typeof THEME_COLORS)[number];

export const DEFAULT_THEME_COLOR: ThemeColor = 'blue';

export const THEME_COLOR_LABELS: Record<ThemeColor, string> = {
  neutral: 'Neutral',
  blue: 'Blue',
  green: 'Green',
  emerald: 'Emerald',
  violet: 'Violet',
  orange: 'Orange',
  rose: 'Rose',
};

export function isThemeColor(value: unknown): value is ThemeColor {
  return typeof value === 'string' && (THEME_COLORS as readonly string[]).includes(value);
}

export function normalizeThemeColor(value: unknown): ThemeColor {
  return isThemeColor(value) ? value : DEFAULT_THEME_COLOR;
}
